<template>
	<div class="accordion__section accordion__section--small-gap"
		:class="{ 'is-active': index === expandedIndex }"
	>
		<header class="accordion__head accordion__head--small-gap">
			<button type="button" @click="setExapandedIndex(index)">
				{{ title }}
			</button>
		</header>

		<div class="accordion__body" v-if="index === expandedIndex">
			<slot />
		</div>
	</div>
</template>

<script setup>
		import { inject } from "vue";
		import { __ } from "@/utils";

		const { expandedIndex, setExapandedIndex } = inject("expandedIndex");
		const props = defineProps({
			title: String,
			index: Number,
			defaultOpen: Boolean,
		});

		if (props.defaultOpen) {
			setExapandedIndex(props.index);
		}
</script>

